import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as SlideIcon } from '@assets/icons/order/slide-icon.svg';

import LoaderComponent from '@components/LoaderComponent';

import useWindowSize from '@hooks/useWindowSize';

import {
	allFilterPages,
	generateSupplierListParams,
	supplierListFilterFields
} from '@features/filter/static/filterUtil';
import FilterComponent from '@features/filter/v2/FilterComponent';
import FilterTopHeaderOfSupplier from '@features/filter/v2/supplier/FilterTopHeaderOfSupplier';
import SupplierListImageView from '@features/supplier/component/SupplierListImageView';
import SupplierListTable from '@features/supplier/component/SupplierListTable';

import { clearFilterResponse, handleFilter } from '@store/actions/FilterAction';

import { fetchDependentFilterList, setSystemUserPreferences } from '@services/commonService';

import { getUserInfo, isPageReachBottom } from '@utils/Util';

const Suppliers = ({ requestFrom, additionalFilters }) => {
	const [isShowFilter, setIsShowFilter] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedViewType, setSelectedViewType] = useState(
		getUserInfo().systemPreference?.supplierListViewType
	);
	const [page, setPage] = useState(0);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [arrowDisable, setArrowDisable] = useState(true);
	let filterfields = useSelector((store) => store.filterFieldStore);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const allSuppliers = useSelector((store) => store.filterResponseStore);
	useWindowSize(() => setIsShowFilter(false));

	// useEffect(() => {
	// 	const { page, size, sort, ...paramsData } = generateSupplierListParams(filterfields);
	// 	dispatch(fetchDependentFilterList({ type: 'SUPPLIER_LIST' }, paramsData));
	// }, [filterfields]);

	const elementRef = useRef(null);
	const scrollRef = useRef({});
	const setCurrentState = (data) => {
		scrollRef.current = data;
	};

	useEffect(() => {
		setCurrentState(allSuppliers);
	}, [allSuppliers]);

	// useEffect(() => {
	// 	window.scrollTo(0, 0);
	// 	setIsLoading(true);
	// 	if (requestFrom === 'CRM') {
	// 		filterfields = { ...filterfields, ...additionalFilters };
	// 	}
	// 	let queryParams = generateSupplierListParams(filterfields, 0);
	// 	dispatch(handleFilter('getSuppliersList', queryParams, false)).finally(() => {
	// 		setIsLoading(false);
	// 	});
	// }, [dispatch]);

	useEffect(() => {
		if (selectedField?.selectedCheckboxField === null) {
			window.scrollTo(0, 0);
			setIsLoading(true);
			if (requestFrom === 'CRM') {
				filterfields = { ...filterfields, ...additionalFilters };
			}

			let queryParams = generateSupplierListParams(filterfields, 0);
			dispatch(handleFilter('getSuppliersList', queryParams, false)).finally(() => {
				setIsLoading(false);
			});
		}
	}, [selectedField, filterfields]);

	useEffect(() => {
		if (page !== 0) {
			setIsLoading(true);
			if (requestFrom === 'CRM') {
				filterfields = { ...filterfields, ...additionalFilters };
			}
			let queryParams = generateSupplierListParams(filterfields, page);
			dispatch(handleFilter('getSuppliersList', queryParams, true)).finally(() => {
				setIsLoading(false);
			});
		}
	}, [page]);

	useEffect(() => {
		if (isShowFilter) {
			const { ...paramsData } = generateSupplierListParams(filterfields);
			dispatch(fetchDependentFilterList({ type: 'SUPPLIER_LIST' }, paramsData));
		}
	}, [isShowFilter, filterfields]);

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			dispatch(clearFilterResponse());
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleScroll = () => {
		if (isPageReachBottom()) {
			let { totalElements, currentPage, data } = scrollRef.current;
			if (totalElements !== data?.length) {
				setPage(() => currentPage + 1);
			}
		}
	};

	const onCollspseFilter = () => setIsShowFilter(!isShowFilter);

	const onSupplierClick = (supplier) => {
		if (supplier?.supplierStatus?.constant === 'NOT_APPROVED') {
			return navigate(`/suppliers/profile/${supplier.id}`);
		} else {
			return navigate(`/suppliers/view/${supplier.id}`);
		}
	};

	// const onSearchSupplier = (searchItem) => {
	// 	dispatch(setFilters({ ...commonFilters, search: searchItem }));
	// };

	// const onSortSupplier = (e) => {
	// 	dispatch(setFilters({ ...commonFilters, sort: e.target.value }));
	// };

	const handleHorizontalScroll = (element, speed, distance, step) => {
		let scrollAmount = 0;
		const slideTimer = setInterval(() => {
			element.scrollLeft += step;
			scrollAmount += Math.abs(step);
			if (scrollAmount >= distance) {
				clearInterval(slideTimer);
			}
			if (element.scrollLeft === 0) {
				setArrowDisable(true);
			} else {
				setArrowDisable(false);
			}
		}, speed);
	};

	const onSetViewSetting = async (selected) => {
		let viewTypeKey = 'supplierListViewType';
		setSelectedViewType(selected);
		let body = {
			[viewTypeKey]: selected
		};
		await setSystemUserPreferences(body);
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="top-header supplier-list-top-header">
				{requestFrom !== 'CRM' && (
					<div className="page-title-area">
						<h1 className="semibold-16">Supplier list</h1>
					</div>
				)}
				<FilterTopHeaderOfSupplier
					addNewTitle="Supplier"
					toggleFilter={onCollspseFilter}
					isShowFilter={isShowFilter}
					selectedViewType={selectedViewType}
					onSetViewSetting={onSetViewSetting}
					totalElements={allSuppliers.totalElements}
					searchBoxPlaceHolder={'Search'}
				/>
				{requestFrom !== 'CRM' && selectedViewType === 'LIST_VIEW' && (
					<div className="scroll-table-buttons suppliers-table-button">
						<button
							className="left"
							onClick={() => {
								handleHorizontalScroll(elementRef.current, 10, 70, -220);
							}}
							disabled={arrowDisable}
						>
							<SlideIcon />
						</button>
						&nbsp;&nbsp;
						<button
							className="right"
							onClick={() => {
								handleHorizontalScroll(elementRef.current, 10, 70, 220);
							}}
						>
							<SlideIcon />
						</button>
					</div>
				)}
			</div>
			<section className="filter-data-container filter-v3-data-container">
				{requestFrom !== 'CRM' && (
					<FilterComponent
						filterPageName={allFilterPages.SUPPLIER_LIST}
						fields={supplierListFilterFields}
						showFilter={isShowFilter}
						isDependentFilter={true}
					/>
				)}
				{selectedViewType === 'LIST_VIEW' ? (
					<div className="data-table scroll-x-label" ref={elementRef}>
						<SupplierListTable
							requestFrom={requestFrom}
							isLoading={isLoading}
							onSupplierClick={onSupplierClick}
							allSuppliers={allSuppliers}
						/>
					</div>
				) : (
					<SupplierListImageView
						requestFrom={requestFrom}
						isLoading={isLoading}
						onSupplierClick={onSupplierClick}
						allSuppliers={allSuppliers}
					/>
				)}
			</section>
		</LoaderComponent>
	);
};

export default Suppliers;
